module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page auth-page auth-login-page",
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Sign in")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "dialog-close-btn",
    nativeOn: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('v-icon', [_vm._v("highlight_off")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    class: {
      input: true,
      'text-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger text-xs-left"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('email')) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "regular-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember),
      expression: "remember"
    }],
    attrs: {
      "id": "remember",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.remember) ? _vm._i(_vm.remember, null) > -1 : (_vm.remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remember = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("Remember me")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": "",
      "text-xs-right": "",
      "text-sm-right": ""
    }
  }, [_c('a', {
    staticClass: "forgot-password",
    on: {
      "click": function($event) {
        _vm.choosePage('forgot')
      }
    }
  }, [_vm._v("Forgot password")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "login-button",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("Sign in")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    staticClass: "or-divider",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('hr', {
    staticClass: "divider"
  })]), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('p', {
    staticClass: "or"
  }, [_vm._v("OR")])]), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('hr', {
    staticClass: "divider"
  })])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('a', {
    staticClass: "create-account mb-4",
    on: {
      "click": function($event) {
        _vm.choosePage('register')
      }
    }
  }, [_vm._v("Create an account")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-444ae4fd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login_dialog.vue
// module id = 1704
// module chunks = 180